const eur = (hodnota) => {
  const cislo = Number(hodnota) || 0;
  return new Intl.NumberFormat('sk-SK', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cislo);
};

const eurAuto = (hodnota) => {
  const cislo = Number(hodnota);

  if (!Number.isFinite(cislo)) return '—';

  const jeCele = Math.abs(cislo % 1) < 0.000001;

  return new Intl.NumberFormat('sk-SK', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: jeCele ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(cislo);
};

const percento = (hodnota, pocet = 2) => {
  const cislo = Number(hodnota) || 0;
  return `${cislo.toFixed(pocet).replace('.', ',')} %`;
};

const cislo = (hodnota, pocet = 0) => {
  const num = Number(hodnota) || 0;
  return new Intl.NumberFormat('sk-SK', {
    minimumFractionDigits: pocet,
    maximumFractionDigits: pocet,
  }).format(num);
};

const datumText = () => {
  return new Intl.DateTimeFormat('sk-SK', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date());
};

const hodnotaText = (hodnota, fallback = '—') => {
  if (hodnota === null || hodnota === undefined || hodnota === '') return fallback;
  return String(hodnota);
};

const maKladnuHodnotu = (hodnota) => Number(hodnota) > 0;

const maPoleSObsahom = (pole) => Array.isArray(pole) && pole.length > 0;

const maGrafSObsahom = (graf) =>
  Array.isArray(graf) && graf.some((hodnota) => Number(hodnota) > 0);

const vekNaText = (hodnota) => (
  Number(hodnota) > 0 ? `${cislo(hodnota)} r.` : '—'
);

const fixaciaNaText = (hodnota) => (
  Number(hodnota) > 0 ? `${cislo(hodnota)} r.` : '—'
);

const splatnostNaText = (hodnota) => (
  Number(hodnota) > 0 ? `${cislo(hodnota)} r.` : '—'
);

const mesiaceNaText = (hodnota) => {
  const mesiace = Number(hodnota);

  if (!Number.isFinite(mesiace) || mesiace <= 0) return '—';

  const roky = Math.floor(mesiace / 12);
  const zvysokMesiacov = mesiace % 12;

  if (roky > 0 && zvysokMesiacov > 0) {
    return `${cislo(roky)} r. ${cislo(zvysokMesiacov)} m.`;
  }

  if (roky > 0) {
    return `${cislo(roky)} r.`;
  }

  return `${cislo(zvysokMesiacov)} m.`;
};

const ltvNaText = (suma, hodnotaZabezpecenia) => {
  const uver = Number(suma) || 0;
  const zabezpecenie = Number(hodnotaZabezpecenia) || 0;

  if (zabezpecenie <= 0) return '—';

  return percento((uver / zabezpecenie) * 100, 2);
};

const ziskajGrafBase64 = (chartRef) => {
  const chart = chartRef?.current;
  if (!chart) return null;

  const sourceCanvas =
    chart.canvas ||
    chart.chart?.canvas ||
    null;

  if (!sourceCanvas) {
    if (typeof chart.toBase64Image === 'function') {
      return chart.toBase64Image();
    }

    if (chart.chart && typeof chart.chart.toBase64Image === 'function') {
      return chart.chart.toBase64Image();
    }

    return null;
  }

  try {
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = sourceCanvas.width;
    tempCanvas.height = sourceCanvas.height;

    const ctx = tempCanvas.getContext('2d');
    if (!ctx) return sourceCanvas.toDataURL('image/png');

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
    ctx.drawImage(sourceCanvas, 0, 0);

    return tempCanvas.toDataURL('image/png');
  } catch (error) {
    if (typeof sourceCanvas.toDataURL === 'function') {
      return sourceCanvas.toDataURL('image/png');
    }

    return null;
  }
};

export function vytvorDataPrePonukuPdf({
  nazovSuboru,
  menoKlienta,
  kontaktMeno,
  kontaktPriezvisko,
  kontaktEmail,
  kontaktTelefon,
  kontaktNbsCislo,
  suma,
  hodnotazabezpecenia,
  urok,
  fixacia,
  roky,
  splatka,
  stresssplatka,
  dtiVysledok,
  stressdti,
  dstistresssplatka,
  typHypoteky,
  pocetziadatelov,
  pocetdeti,

  pocetdeti2,
  pocetdeti3,
  pocetdeti4,
  vek1,
  prijem1,
  vek2,
  prijem2,
  vek3,
  prijem3,
  vek4,
  prijem4,
  Hypoobjem,
  Hyposplatnost,
  Hyposadzba,
  Hyposplatka,
  Hypofixacia,
  Ostatneobjem,
  Ostatnesplatka,
  Hypoobjem2,
  Hyposplatnost2,
  Hyposadzba2,
  Hyposplatka2,
  Hypofixacia2,
  Ostatneobjem2,
  Ostatnesplatka2,
  Hypoobjem3,
  Hyposplatnost3,
  Hyposadzba3,
  Hyposplatka3,
  Hypofixacia3,
  Ostatneobjem3,
  Ostatnesplatka3,
  Hypoobjem4,
  Hyposplatnost4,
  Hyposadzba4,
  Hyposplatka4,
  Hypofixacia4,
  Ostatneobjem4,
  Ostatnesplatka4,

  poznamka,
  fincloudTip,
  ppOpen,
  ppRezim,
  ppJednoraz,
  ppMesacne,
  ppRocne,
  ppStart,
  ppOpakovania,
  resultA,
  resultB,
  exceededRelevant,
  invOpen,
  invProfil,
  invJednoraz,
  invMesacne,
  invZhodnotenie,
  invHorizont,
  invVystupPS,
  vysledokInvestovania,
  splatkovyKalendar,
  splatkovyKalendarPS_skratenie,
  splatkovyKalendarPS_znizenie,
  investicnyPriebeh,
  porovnavacDataPrePdf,
  chartRef,
}) {
  const grafBase64 = ziskajGrafBase64(chartRef);

  const kontaktMenoCele = [kontaktMeno, kontaktPriezvisko]
    .map((cast) => String(cast || '').trim())
    .filter(Boolean)
    .join(' ')
    .trim();

  const aktivnyVysledokPS =
    ppRezim === 'skratenie' ? resultA : resultB;

  const kalendarPS =
    ppRezim === 'skratenie'
      ? splatkovyKalendarPS_skratenie
      : splatkovyKalendarPS_znizenie;

  const tipy = Array.isArray(fincloudTip?.tipy) ? fincloudTip.tipy : [];
  const sablona = fincloudTip?.sablona || {
    pred: '',
    pred2: '',
    stred: '',
    za: '',
    za2: '',
  };

  const pocetZiadatelovCislo = Math.max(1, Number(pocetziadatelov) || 1);

  const ziadateliaPdf = [
    {
      poradie: 1,
      vek: vek1,
      prijem: prijem1,
      pocetdeti: pocetdeti,
    },
    {
      poradie: 2,
      vek: vek2,
      prijem: prijem2,
      pocetdeti: pocetdeti2,
    },
    {
      poradie: 3,
      vek: vek3,
      prijem: prijem3,
      pocetdeti: pocetdeti3,
    },
    {
      poradie: 4,
      vek: vek4,
      prijem: prijem4,
      pocetdeti: pocetdeti4,
    },
  ].slice(0, pocetZiadatelovCislo);

  const zavazkyPdf = [
    {
      poradie: 1,
      hypoobjem: Hypoobjem,
      hyposplatnost: Hyposplatnost,
      hyposadzba: Hyposadzba,
      hyposplatka: Hyposplatka,
      hypofixacia: Hypofixacia,
      ostatneobjem: Ostatneobjem,
      ostatnesplatka: Ostatnesplatka,
    },
    {
      poradie: 2,
      hypoobjem: Hypoobjem2,
      hyposplatnost: Hyposplatnost2,
      hyposadzba: Hyposadzba2,
      hyposplatka: Hyposplatka2,
      hypofixacia: Hypofixacia2,
      ostatneobjem: Ostatneobjem2,
      ostatnesplatka: Ostatnesplatka2,
    },
    {
      poradie: 3,
      hypoobjem: Hypoobjem3,
      hyposplatnost: Hyposplatnost3,
      hyposadzba: Hyposadzba3,
      hyposplatka: Hyposplatka3,
      hypofixacia: Hypofixacia3,
      ostatneobjem: Ostatneobjem3,
      ostatnesplatka: Ostatnesplatka3,
    },
    {
      poradie: 4,
      hypoobjem: Hypoobjem4,
      hyposplatnost: Hyposplatnost4,
      hyposadzba: Hyposadzba4,
      hyposplatka: Hyposplatka4,
      hypofixacia: Hypofixacia4,
      ostatneobjem: Ostatneobjem4,
      ostatnesplatka: Ostatnesplatka4,
    },
  ].slice(0, pocetZiadatelovCislo);

  const maPredcasneSplatenieObsah = Boolean(
    ppOpen && (
      maKladnuHodnotu(ppJednoraz) ||
      maKladnuHodnotu(ppMesacne) ||
      maKladnuHodnotu(ppRocne) ||
      maPoleSObsahom(aktivnyVysledokPS?.events) ||
      maPoleSObsahom(kalendarPS)
    )
  );

  const maInvestovanieObsah = Boolean(
    invOpen && (
      maKladnuHodnotu(invJednoraz) ||
      maKladnuHodnotu(invMesacne) ||
      maGrafSObsahom(investicnyPriebeh) ||
      maGrafSObsahom(vysledokInvestovania?.graf)
    )
  );

  const parametreHypotekyPdf = [
    { label: 'Typ hypotéky', value: hodnotaText(typHypoteky, '—') },
    {
      label: 'Výška hypotéky',
      value: eurAuto(suma),
      labelTucne: true,
      valueTucne: true,
    },
    { label: 'LTV', value: ltvNaText(suma, hodnotazabezpecenia) },
    { label: 'Fixácia', value: fixaciaNaText(fixacia) },
    {
      label: 'Úrok',
      value: percento(urok),
      labelTucne: true,
      valueTucne: true,
    },
    { label: 'Splatnosť', value: splatnostNaText(roky) },
    {
      label: 'Splátka',
      value: eur(splatka),
      labelTucne: true,
      valueTucne: true,
    },
    { label: 'Splátka + stress test', value: eur(stresssplatka) },
  ];

  const ziadateliaPrehladPdf = ziadateliaPdf.map((ziadatel) => ({
    label: `Žiadateľ ${ziadatel.poradie}`,
    value: [
      `Vek: ${vekNaText(ziadatel.vek)}`,
      `Príjem: ${eurAuto(ziadatel.prijem)}`,
      `Deti: ${cislo(ziadatel.pocetdeti)}`,
    ].join('  |  '),
  }));

  const zavazkyPrehladPdf = zavazkyPdf.map((zavazok) => ({
    label: `Žiadateľ ${zavazok.poradie}`,
    bloky: [
      {
        nadpis: 'Hypotéky',
        text: [
          `zostatok ${maKladnuHodnotu(zavazok.hypoobjem) ? eurAuto(zavazok.hypoobjem) : '—'}`,
          `splátka ${maKladnuHodnotu(zavazok.hyposplatka) ? eurAuto(zavazok.hyposplatka) : '—'}`,
          `fixácia ${maKladnuHodnotu(zavazok.hypofixacia) ? fixaciaNaText(zavazok.hypofixacia) : '—'}`,
          `úrok ${maKladnuHodnotu(zavazok.hyposadzba) ? percento(zavazok.hyposadzba) : '—'}`,
          `zost. splatnosť ${maKladnuHodnotu(zavazok.hyposplatnost) ? mesiaceNaText(zavazok.hyposplatnost) : '—'}`,
        ].join(', '),
      },
      {
        nadpis: 'Ostatné úvery',
        text: [
          `zostatok ${maKladnuHodnotu(zavazok.ostatneobjem) ? eurAuto(zavazok.ostatneobjem) : '—'}`,
          `splátka ${maKladnuHodnotu(zavazok.ostatnesplatka) ? eurAuto(zavazok.ostatnesplatka) : '—'}`,
        ].join(', '),
      },
    ],
  }));

  const rozdielDisponaSplatku = (Number(dstistresssplatka) || 0) - (Number(stresssplatka) || 0);

  const limityPdf = [
    {
      label: 'Maximálna výška úveru',
      value: eurAuto(stressdti),
      labelTucne: true,
      valueTucne: true,
    },
    {
      label: '↳ DTI',
      value: eurAuto(dtiVysledok),
      odsadenie: 4,
    },
    {
      label: '↳ Stress DTI',
      value: eurAuto(stressdti),
      odsadenie: 4,
    },
    {
      label: 'Maximálna splátka (DSTI)',
      value: eur(dstistresssplatka),
      labelTucne: true,
      valueTucne: true,
    },
    {
      label: '↳ Rozdiel (dispo na splátku)',
      value: eurAuto(rozdielDisponaSplatku),
      odsadenie: 4,
    },
  ];

  return {
    metadata: {
      nazovSuboru: (nazovSuboru || '').trim(),
      menoKlienta: (menoKlienta || '').trim(),
      datumVyhotovenia: datumText(),
      typHypoteky,
    },

    kontaktPdf: {
      meno: kontaktMenoCele,
      email: kontaktEmail || '',
      telefon: kontaktTelefon || '',
      nbsCislo: kontaktNbsCislo || '',
    },

    prehladPdf: {
      parametreHypotekyPdf,
      ziadateliaPrehladPdf,
      zavazkyPrehladPdf,
      limityPdf,
      grafBase64,
    },

    vypocty: {
      suma,
      hodnotazabezpecenia,
      urok,
      fixacia,
      roky,
      splatka,
      stresssplatka,
      dtiVysledok,
      stressdti,
      dstistresssplatka,
      pocetziadatelov,
      pocetdeti,

      riadky: [
        { label: 'Výška úveru', value: eur(suma) },
        { label: 'Hodnota zabezpečenia', value: eur(hodnotazabezpecenia) },
        { label: 'Úroková sadzba', value: percento(urok) },
        { label: 'Fixácia', value: `${cislo(fixacia)} r.` },
        { label: 'Splatnosť', value: `${cislo(roky)} r.` },
        { label: 'Mesačná splátka', value: eur(splatka) },
        { label: 'Stress splátka', value: eur(stresssplatka) },
        { label: 'DTI', value: cislo(dtiVysledok) },
        { label: 'Stress DTI max. úver', value: eur(stressdti) },
        { label: 'DSTI stress splátka', value: eur(dstistresssplatka) },
      ],
    },

    fincloudTip: {
      sablona,
      tipy,
      maTipy: tipy.length > 0,
    },

    predcasneSplatenie: {
      aktivne: maPredcasneSplatenieObsah,
      rezim: ppRezim,
      jednoraz: ppJednoraz,
      mesacne: ppMesacne,
      rocne: ppRocne,
      start: ppStart,
      opakovania: ppOpakovania,
      exceededRelevant: exceededRelevant || [],
      vysledok: aktivnyVysledokPS
        ? {
            payoffMonth: aktivnyVysledokPS.payoffMonth,
            monthsSaved: aktivnyVysledokPS.monthsSaved,
            savedInterest: aktivnyVysledokPS.savedInterest,
            totalInterestBase: aktivnyVysledokPS.totalInterestBase,
            totalInterestPP: aktivnyVysledokPS.totalInterestPP,
            totalPaidBase: aktivnyVysledokPS.totalPaidBase,
            totalPaidPP: aktivnyVysledokPS.totalPaidPP,
            firstNewPayment: aktivnyVysledokPS.firstNewPayment ?? null,
            avgPayment: aktivnyVysledokPS.avgPayment ?? null,
          }
        : null,
    },

    investovanie: {
      aktivne: maInvestovanieObsah,
      profil: invProfil,
      jednoraz: invJednoraz,
      mesacne: invMesacne,
      zhodnotenie: invZhodnotenie,
      horizont: invHorizont,
      vystupPS: invVystupPS,
      vysledok: vysledokInvestovania
        ? {
            konecnaHodnota:
              vysledokInvestovania.konecnaHodnota ??
              vysledokInvestovania.konecnyStavBezPS ??
              0,
            vlozeneProstriedky:
              vysledokInvestovania.vlozeneProstriedky ??
              vysledokInvestovania.celkoveVklady ??
              0,
            vynos:
              vysledokInvestovania.vynos ??
              vysledokInvestovania.celkovyVynos ??
              0,
            mesiacSplatenia: vysledokInvestovania.mesiacSplatenia ?? null,
            usetreneMesiace: vysledokInvestovania.usetreneMesiace ?? null,
            zostatokPoSplateni: vysledokInvestovania.zostatokPoSplateni ?? 0,
          }
        : null,
      investicnyPriebeh: investicnyPriebeh || null,
    },

    splatkovyKalendar: {
      bezny: Array.isArray(splatkovyKalendar) ? splatkovyKalendar : [],
      sPredcasnymSplatenim: Array.isArray(kalendarPS) ? kalendarPS : [],
      zobrazitPredcasneSplatenie: maPredcasneSplatenieObsah,
      zobrazitInvestovanie: maInvestovanieObsah,
    },

    graf: {
      obrazokBase64: grafBase64,
      maGraf: Boolean(grafBase64),
    },

    porovnavac: {
      ...porovnavacDataPrePdf,
      maData: Array.isArray(porovnavacDataPrePdf?.zobrazeneBanky) && porovnavacDataPrePdf.zobrazeneBanky.length > 0,
    },

    poznamka: {
      text: (poznamka || '').trim(),
      maText: Boolean((poznamka || '').trim()),
    },
  };
}